import type { SpotListItem } from "@divespots/contracts";
import type { Ref } from "react";
import type { Detent } from "../components/Sheet.tsx";
import { PermanentClosureNote, SpotBadges } from "./SpotBadges.tsx";

const TITLE_CLASS: Record<Detent, string> = {
  peek: "ds-text-title-3",
  medium: "ds-text-title-1",
  large: "ds-text-large-title",
};

interface Props {
  spot: Pick<
    SpotListItem,
    | "name"
    | "locality"
    | "waterBody"
    | "difficulty"
    | "maxDepthM"
    | "closedPeriods"
    | "permanentClosure"
    | "objectCount"
  >;
  detent: Detent;
  now?: Date | undefined;
  titleRef?: Ref<HTMLHeadingElement> | undefined;
}

/** Name, "locality · water body" and the badge row (the part that stays visible at the peek detent). */
export function SpotHeader({ spot, detent, now, titleRef }: Props) {
  const place = [spot.locality, spot.waterBody].filter(Boolean).join(" · ");
  return (
    <header className="ds-sheet__head">
      <h2 ref={titleRef} tabIndex={-1} className={`${TITLE_CLASS[detent]} spot-sheet__title`}>
        {spot.name}
      </h2>
      {place ? (
        <p
          className={`${detent === "peek" ? "ds-text-footnote" : "ds-text-subheadline"} ds-sheet__meta spot-sheet__meta`}
        >
          {place}
        </p>
      ) : null}
      <SpotBadges spot={spot} now={now} />
      <PermanentClosureNote spot={spot} />
    </header>
  );
}
